<template>
	<app-page>
		<app-heading title="Integrations" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="integrations"
					:total="count"
					:headers="headers"
					@update="fetchIntegrations"
				>
					<template v-slot:actions="{ item }">
						<app-button
							color="secondary"
							:to="{ name: 'integration', params: { integration: item._id } }"
							table
							:disabled="item.microlyth"
						>
							Manage
						</app-button>
						<app-button
							color="secondary"
							:to="{ name: 'integration-logs', params: { integration: item._id } }"
							table
							:disabled="item.microlyth"
						>
							Logs
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			integrations: [],
			count: -1,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchIntegrations(pagination) {
			const request = this.$ravello.request()
				.v(2)
				.to('integrations')
				.fromPagination(pagination)
				.fields(['name', 'slug', 'microlyth'])

			try {
				this.integrations = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
